export const containerWidth = {
  mobile: '100vw',
  tablet: '650px',
  desktop: '1559px',
  desktopLarge: '896px',
}
